import { faReadme } from "@fortawesome/free-brands-svg-icons";
import { faCogs, faRuler } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavLink } from "react-router-dom";
import { useUserInfor } from "../../../../../Context/User";
import { ACESSOS } from "../../../../../Routes/Acessos";
import { mostrarNavDeTela } from "../../../../../Validations/UsuarioTela";

export function SubNavGestaoRegua() {
    const { UserInfor } = useUserInfor();

    return (
        <div className="menu-submenu menu-submenu-classic menu-submenu-left">
            <ul className="menu-subnav">
                {mostrarNavDeTela(
                    ACESSOS.AUTOMACAO.TELAS.REGUA.CONFIG.ID_TELA,
                    UserInfor.TELAS
                ) && (
                    <li className="menu-item">
                        <NavLink
                            to={ACESSOS.AUTOMACAO.TELAS.REGUA.CONFIG.DS_PATH}
                            className="menu-link"
                        >
                            <span className="svg-icon menu-icon">
                                <FontAwesomeIcon icon={faCogs} />
                            </span>
                            <span className="menu-text">
                                Configuração De Réguas
                            </span>
                        </NavLink>
                    </li>
                )}
            </ul>
            <ul className="menu-subnav">
                {mostrarNavDeTela(
                    ACESSOS.AUTOMACAO.TELAS.REGUA.GESTAO.ID_TELA,
                    UserInfor.TELAS
                ) && (
                    <li className="menu-item">
                        <NavLink
                            to={ACESSOS.AUTOMACAO.TELAS.REGUA.GESTAO.DS_PATH}
                            className="menu-link"
                        >
                            <span className="svg-icon menu-icon">
                                <FontAwesomeIcon icon={faRuler} />
                            </span>
                            <span className="menu-text">Gestão Das Réguas</span>
                        </NavLink>
                    </li>
                )}
            </ul>

            <ul className="menu-subnav">
                {mostrarNavDeTela(
                    ACESSOS.AUTOMACAO.TELAS.REGUA.RELATORIOS.ID_TELA,
                    UserInfor.TELAS
                ) && (
                    <li className="menu-item">
                        <NavLink
                            to={
                                ACESSOS.AUTOMACAO.TELAS.REGUA.RELATORIOS.DS_PATH
                            }
                            className="menu-link"
                        >
                            <span className="svg-icon menu-icon">
                                <FontAwesomeIcon icon={faReadme} />
                            </span>
                            <span className="menu-text">
                                Relatórios de Envio
                            </span>
                        </NavLink>
                    </li>
                )}
            </ul>
            <ul className="menu-subnav">
                {mostrarNavDeTela(
                    ACESSOS.AUTOMACAO.TELAS.REGUA.RELATORIOS_BI.ID_TELA,
                    UserInfor.TELAS
                ) && (
                    <li className="menu-item">
                        <NavLink
                            to={
                                ACESSOS.AUTOMACAO.TELAS.REGUA.RELATORIOS_BI
                                    .DS_PATH
                            }
                            className="menu-link"
                        >
                            <span className="svg-icon menu-icon">
                                <FontAwesomeIcon icon={faReadme} />
                            </span>
                            <span className="menu-text">Relatório BI</span>
                        </NavLink>
                    </li>
                )}
            </ul>
        </div>
    );
}
